import React from "react";
import { THEME_COLORS } from "../../../../../color";

const Card = ({
  icon = null,
  title = "",
  value = "",
  footer = "",
  footerBg,
}) => {
  return (
    <div className="w-full bg-[#30B7921F] h-auto min-h-[12rem] sm:min-h-[15rem] md:min-h-[15rem] flex flex-col p-0 rounded-2xl">
      <div className="flex gap-x-4 items-center p-4 sm:p-4 md:p-4">
        <div className="">{icon}</div>
        <h2
          className="text-lg sm:text-xl md:text-2xl font-semibold m-0 p-0"
          style={{ color: THEME_COLORS.green }}
        >
          {title}
        </h2>
      </div>

      <div
        className="px-6 sm:px-10 md:px-20 flex-grow text-2xl sm:text-3xl font-semibold flex items-center pt-0"
        style={{ color: THEME_COLORS.green }}
      >
        {value}
      </div>

      <div
        style={{ background: THEME_COLORS.green }}
        className="text-white font-light text-sm sm:text-base p-3 rounded-b-2xl  items-center justify-center flex  mt-auto"
      >
        {footer}
      </div>
    </div>
  );
};

export default Card;
